<ng-container *ngIf="!loadingData">
	<div class="widget-title"
	[matTooltip]="'dashboard.rts-widget.tooltip'|translate"
	translate>{{productTypeLabel}}</div>
	<div class="widget-weight-type" translate>{{weightTypeLabel}}</div>
	<div class="steel-grade-row" *ngFor="let rtsValue of rtsValues; let i = index">
		{{ rtsValue.reference ? rtsValue.reference : ('dashboard.without-value' | translate) }} <span class="steel-grade-value">{{rtsValue.value | copoNumber: 'weight':'t'}}</span>
	</div>
</ng-container>
<copo-loading-spinner *ngIf="loadingData"></copo-loading-spinner>